import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../components/master/Modal';
import { Link } from 'react-router-dom';
import { numToPrice, pexios } from '../../utils/functions';
import { setUser } from '../../redux/actions';
import { useTranslation } from 'react-i18next';
import { TitleContext } from '../../App';

export default function Rules() {
    const { t } = useTranslation();
    const user = useSelector((store) => store.user);
    const accept = user.check_privacy;
    const [acceptance , setAcceptance] = useState(false);
    const [modal,setModal] = useState(false);
    const [giftPrice, setGiftPrice] = useState(0)
    const dispatch = useDispatch()
    // const {setTitle} = useContext(TitleContext);
    // useEffect(()=>{
    //     setTitle('شرایط و قوانین')
    // },[])
    function submit(){
        acceptance && pexios('/api/accept_privacy')
        .then((res)=>{
            setGiftPrice(res.data)
            setModal(true);
            dispatch(setUser({...user, check_privacy: 1}))
        })
    }

    return (
        <div className='content rules'>
            {/* {modal && */}
            <Modal visible={modal}>
                <div className="modal-content text-justify p20">
                    {/* <i className='fas fa-times pt10' onClick={() => setModal(false)} /> */}
                        <div className='rule-modal' style={{maxWidth: 500}}>
                        {/* <img src={giftBox} alt="giftImage"/> */}
                        <p className='pb10 pr10'>
                        {`${user.full_name} ${t('Dear')}`}
                        </p>
                        <p className='ruleModal-text'>
                            {/* {`از ادامه همکاری با شما بسیار خرسندیم. به پاس قدردانی مبلغ ${numToPrice(giftPrice)}  ریال در کیف پول شما شارژ گردید.`} */}
                            {t('Modal greatful message',{price : numToPrice(giftPrice)})}
                        </p>
                        </div>
                        <Link
                        to="/"
                        className="btn btn-block mt20 btn-blue btn-circle"
                        >
                        {t('Continue')}
                        </Link>
            </div>
            </Modal>
            {/* } */}
            <p className='mt20 title rule-title'>
                {t('Rules and condition title')}
                <p className='mt5' style={{fontSize : '13px'}}>(سکوی هوشمند خدمات شرکت اوج آفرینان خلیج فارس)</p>
            </p>
            <p className='mt20 subtitle'>{t('Defenitaion and phases')}</p>
            <p className='mt10'>
                {/* ۱-۱- موسسه: موسسه ارزیاب خسارت بالن که نسبت به ارائه خدمات در اپلیکیشن و وب سایت اقدام میکند. */}
                {t('Defenitaion and phases 1-1')}
            </p>
            <p className='mt10'>
                {/* ۱-۲-موسسه ارزیاب خسارت بالن: خدمات نرم‌افزاری که توسط موسسه به منظور تعیین خسارت های مالی در بیمه نامه های ثالث و بدنه (فقط مشتریان آن دسته از شرکت های بیمه که با موسسه قرارداد همکاری داشته باشند) ارائه میشود */}
                {t('Defenitaion and phases 1-2')}
            </p>
            <p className='mt10'>
                {/* ۱-3- اپلیکیشن: نرم‌افزار متعلق به موسسه که به منظور استفاده از خدمات 'موسسه ارزیاب خسارت بالن' ، حق استفادۀ موقت از آن برابر شرایط مندرج در قرارداد خصوصی و سند حاضر به کاربران یا طرف‌های تجاری موسسه اعطا می‌شود. */}
                {t('Defenitaion and phases 1-3')}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-4')}
                {/* ۱-4- قرارداد خصوصی: توافق کتبی یا الکترونیکی فی‌مابین موسسه و کارشناسان تعیین خسارت یا طرف‌های تجاری موسسه، جهت بهره‌برداری موقت از نرم‌افزار موسسه ارزیاب خسارت بالن. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-5')}
                {/* ۱-5- کاربر: شخصی حقیقی یا حقوقی است اعم از کارشناس، ارگان دولتی یا شرکت های بیمه که از طریق اینترنت به اپلیکیشن یا وب سایت متصل و از خدمات اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن' بهره‌مند می‌شود. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-6')}
                {/* ۱-6- کاربران: از کاربر کارشناس یا زیان دیده یا هر شخص حقیقی یا حقوقی که به عضویت اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن' درآمده باشد. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-7')}
                {/* ۱-7- کاربر کارشناس: شخص حقیقی است که در اپلیکیشن کارشناسی 'موسسه ارزیاب خسارت بالن 'جهت دریافت پیشنهاد تعیین خسارت عضو شده و دارای قرارداد کتبی با موسسه موسسه ارزیاب خسارت بالن خلیج فارس است. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-8')}
                {/* ۱-8- کاربر زیاندیده: شخص حقیقی یا حقوقی است که در اپلیکیشن زیاندیده 'موسسه ارزیاب خسارت بالن' برای ارسال درخواست کارشناسی خسارت مالی اتومبیل عضو شده است. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-9')}
                {/* ۱-9- طرف تجاری: اشخاص حقیقی و حقوقی که برابر قرارداد خصوصی از طریق عضویت در 'موسسه ارزیاب خسارت بالن' از خدمات اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن' استفاده میکنند. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-10')}
                {/* ۱-۱0- حساب کاربری: حسابی است که اشخاص برای استفاده از خدمات “موسسه ارزیاب خسارت بالن” در اپلیکیشن ایجاد کرده‌اند. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-11')}
                {/* ۱-۱1- اطلاعات محرمانه: اطلاعاتی که توسط کاربران در اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن' قرار داده می‌شود، اعم از اطلاعاتی که به صورت مستقیم از سوی کاربران وارد می‌شود و همچنین اطلاعاتی که به صورت خودکار و در نتیجۀ بهره‌برداری از خدمات اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن' توسط موسسه یا طرف‌های تجاری تولید یا در اختیار موسسه قرار داده می‌شود. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 1-12')}
                {/* ۱-۱2- قوانین و مقررات جمهوری اسلامی ایران: قانون اساسی، قوانین عادی، آئین‌نامه‌های اجرایی، بخشنامه‌ها، دستورالعمل‌ها و کلیه ضوابط قانونی حاکم بر انجام موضوع قرارداد اعم از قانون بیمه اجباری شخص ثالث، بیمه بدنه، آئین نامه راهنمائی و رانندگی، قوانین بیمه مرکزی جمهوری اسلامی ایران و دستورالعمل ها و آیین نامه های آن. */}
            </p>
            <p className='mt20 subtitle'>{t('Defenitaion and phases 2 clause')}</p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-1')}
                {/* ۲-۱- کاربران با ثبت‌نام در اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن'، همچنین با هر بار استفاده از خدمات آن، می‌پذیرند که شرایط و قوانین حاضر را به صورت کامل مطالعه کرده و آن را با اطلاع کامل از شرایط و معانی‌اش پذیرفته‌اند. این شرایط و قوانین ممکن است در طول زمان تغییر کند. استفادۀ کاربران از اپلیکیشن یا وب سایت، پس از هر بار تغییر در شرایط و قوانین، به معنی پذیرش تغییرات مذکور است. این قوانین برای مطالعه کاربران در سایت و اپلیکیشن 'موسسه ارزیاب خسارت بالن' در دسترس است. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-2')}
                {/* ۲-۲- برای استفاده از خدمات اپلیکیشن یا وب سایت “موسسه ارزیاب خسارت بالن” لازم است که هر کاربر اعم از شخص حقیقی یا حقوقی یک حساب کاربری در اپلیکیشن یا وب سایت بسازد. تنها اشخاصی که بیش از ۱۸ سال سن دارند و واجد اهلیت قانونی هستند می‌توانند اقدام به ساخت حساب کاربری در اپلیکیشن کنند. کاربر مذکور برای استفاده از خدمات باید نام، نام خانوادگی و شماره همراه خود را در اپلیکیشن 'موسسه ارزیاب خسارت بالن' ثبت کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-3')}
                {/* ۲-۳- کاربران شخص حقوقی مکلف به معرفی نماینده (شخص حقیقی) برای ثبت‌نام در اپلیکیشن یا وب سایت هستند و اطلاعات این شخص حقوقی باید در اپلیکیشن قید شود. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-4')}
                {/* ۲-۴- هیچ یک از کاربران حق استفاده از ربات و نرم‌افزارهای مرتبط یا واسط را برای استفاده از اپلیکیشن اعم از احراز هویت، تکمیل اطلاعات، ارسال درخواست و غیره ندارند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-5')}
                {/* ۲-۵- کاربران می‌پذیرند کلیه اطلاعات درخواستی اپلیکیشن را مطابق با واقعیت، صحیح و به‌‌روز وارد کنند و شخص کاربر مسئول عدم صحت و به‌ روز نبودن اطلاعات است. در صورت اثبات خلاف این موضوع، موسسه هیچ گونه مسئولیتی در مورد خسارات و مشکلات ناشی از عدم اعتبار اطلاعات اعلامی بر عهده نخواهد داشت. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-6')}
                {/* ۲-۶- کاربران متعهد می‌شوند که صرفا با شماره تلفن همراه متعلق به خود در اپلیکیشن ثبت‌نام کنند. در غیر این صورت در برابر شخص ذی‌نفع صاحب شماره تلفن همراه تماما مسئول بوده و موسسه به محض آگاهی از این موضوع مجاز خواهد بود نسبت به لغو عضویت و حساب کاربری اقدام کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-7')}
                {/* ۲-۷- هر شخص تنها می‌تواند یک حساب کاربری به عنوان کاربر 'زیاندیده' یا کاربر کارشناس داشته باشد. در صورتی که موسسه اطلاع یابد که به نام یک شخص اعم از حقیقی و یا حقوقی حساب‌های کاربری متعدد وجود دارد، مجاز خواهد بود نسبت به قطع خدمات و غیرفعال کردن حساب‌های کاربری مذکور اقدام کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-8')}
                {/* ۲-۸- مسئولیت همۀ فعالیت‌هایی که از طریق حساب کاربری اشخاص حقیقی و یا حقوقی در اپلیکیشن یا وب سایت 'موسسه ارزیاب خسارت بالن' یا سایر خدمات ارائه شده انجام می‌شود، به عهدۀ کاربران است. بنابراین مسئولیت اشخاص ثالث یا افراد غیر از کاربر که با استفاده از حساب کاربری وی از خدمات اپلیکیشن یا وب سایت استفاده می‌کند تماما متوجه کاربر صاحب حساب است. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-10')}
                {/* ۲-۱۰- کاربران حق ندارند به سایر اشخاص حقیقی و حقوقی اجازه استفاده از حساب کاربری خود را بدهند یا حساب خود را به شخص حقیقی یا حقوقی دیگری منتقل کنند. در مورد کاربر شخص حقوقی نیز، مسئولیت‌های قانونی بهره‌برداری از خدمات اپلیکیشن یا وب سایت “موسسه ارزیاب خسارت بالن” متوجه مدیران اشخاص حقوقی خواهد بود. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-11')}
                {/* ۲-۱۱- در شرایط خاصی ممکن است از کاربران برای استفاده از خدمات، درخواست احراز هویت شود، در این شرایطی اگر کاربران اطلاعات کافی در اختیار موسسه قرار ندهند، موسسه می‌تواند حساب کاربری آن‌ها را مسدود و از ارائه خدمات به نامبردگان خودداری کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-12')}
                {/* ۲-۱۲- ممکن است بنا به مورد و حسب صلاحدید موسسه، از کاربران درخواست شود که اقدام به تکمیل اطلاعات، ارائه مدارک و یا اصلاح اطلاعات موجود کنند. در این صورت، کاربر متعهد به ارائه اطلاعات و یا اصلاح اطلاعات درخواستی در مدت اعلام و درخواست شده از سوی موسسه خواهد بود. در غیر این صورت موسسه می‌تواند حساب کاربری وی را مسدود کرده و از ارائه خدمات به کاربر مذکور خودداری کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 2-13')}
                {/* ۲-۱۳- اطلاعات کاربری کلیه کاربران نزد کاربر گیرنده اطلاعات، محرمانه بوده و هیچ یک از کاربران حق ندارند اطلاعات مربوط به حساب طرف مقابل را (اعم از مشخصات هویتی، شماره تماس، آدرس، عکس و غیره) ذخیره، یا منتشر کند و در دسترس دیگران قرار دهد. */}
            </p>
            <p className='mt20 subtitle'>{t('Defenitaion and phases 3 clause')}</p>
            <p className='mt10'>
                {t('Defenitaion and phases 3-1')}
                {/* ۳-1- با استفاده از خدمات 'موسسه ارزیاب خسارت بالن'، کاربران می‌پذیرند و موظف هستند که از خدمات ارائه شده برای انجام هیچ فعالیت غیر‌قانونی طبق قوانین جمهوری اسلامی ایران، خلاف شرع و مخالف با عرف جامعه استفاده نکنند. */}
            </p>
            <p className='mt10'>
                {t('Defenitaion and phases 3-2')}
                {/* ۳-2- کاربران متعهد می‌شوند هیچ‌گاه از خدمات 'موسسه ارزیاب خسارت بالن' به صورتی که به 'موسسه ارزیاب خسارت بالن'، طرف تجاری و شرکای آن صدمه‌ای وارد کند استفاده نکنند. در صورتی که کاربران نسبت به سوءاستفاده از امکانات فراهم شده در خدمات 'موسسه ارزیاب خسارت بالن' در جهت منافع شخصی و یا آسیب مادی یا معنوی به منافع موسسه اقدام کنند، شرکت ضمن داشتن حق قطع خدمات و غیرفعال کردن حساب کاربری آنها، مجاز خواهد بود، با مراجعه به مراجع ذیصلاح، نسبت به پیگیری قانونی از جمله مطالبه خسارات وارده اقدام کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 3-3')}
                {/* ۳-3- کاربران می‌پذیرند که موسسه ممکن است از ارسال پیامک، ایمیل و یا Push Notification به عنوان راه ارتباطی با آنها استفاده کند. کاربران می‌توانند درخواست کنند که ارسال این پیام‌ها قطع شود، اما با انصراف از دریافت این پیام‌ها مشکلات احتمالی در استفاده از خدمات “موسسه ارزیاب خسارت بالن” را می‌پذیرند و ممکن است اطلاعات مقتضی را به موقع دریافت نکنند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 3-4')}
                {/* ۳-4- مسئولیت تامین اینترنت و سخت‌افزار لازم و هم‌چنین پرداخت هزینه‌های مربوط به آن‌ها برای استفاده از خدمات “موسسه ارزیاب خسارت بالن” به عهدۀ کاربران است. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 3-5')}
                {/* ۳-5-کاربران متعهد می‌شوند پس از اتمام استفاده از خدمات ارائه شده در اپلیکیشن یا وب سایت، از اطلاعاتی که در نتیجۀ استفاده از خدمات “موسسه ارزیاب خسارت بالن” کسب کرده‌اند، هیچ‌گونه استفاده‌ای نکنند. طبعاً ذخیره کردن اطلاعات کاربران در دستگاه تلفن همراه یا به هر شیوۀ دیگر مغایر با قوانین “موسسه ارزیاب خسارت بالن” است. همچنین کاربران متعهد می‌شوند در طول زمان استفاده از خدمات و اپلیکیشن “موسسه ارزیاب خسارت بالن”، فقط در شرایط ضروری و به میزان مورد نیاز از اطلاعاتی که از کاربران ارائه شده است، استفاده کنند. استفادۀ کاربران از این اطلاعات باید مطابق با عرف جامعه و قوانین جمهوری اسلامی ایران باشد. در هر صورت اطلاعات مذکور به صورت امانت در اختیار کاربران قرار گرفته است و در صورت نقض تعهدات مذکور، موسسه و شخص ذینفع مجاز به پیگیری حقوقی و کیفری موضوع خواهد بود. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 3-6')}
                {/* ۳-6- کاربران متعهد به رعایت همۀ شرایط و قوانین، اصول اسلامی، شرعی، اخلاقی و اجتماعی جمهوری اسلامی ایران در هنگام استفاده از “موسسه ارزیاب خسارت بالن” هستند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 3-6-1')}
                {/* تبصره ۲- در صورت رد بی‌دلیل درخواست ارزیابی توسط کاربر کارشناس، شرکت می‌تواند نسبت به غیرفعال کردن حساب کاربری آنها به صورت موقت یا دائم اقدام کند. */}
            </p>
            <p className='mt10'>
            {t('Defenitaion and phases 3-7')}
                {/* ۳-7- خدمات “موسسه ارزیاب خسارت بالن” به غیر از مواردی که منع قانونی دارد ممکن است با مشارکت خدمات شرکت‌ها یا طرف تجاری دیگری ارائه شود که شرکت “موسسه ارزیاب خسارت بالن” کنترلی روی آن‌ها ندارد. در چنین شرایطی کاربران می‌پذیرند که این خدمات، شرایط و قوانین مختص خود را دارند و “موسسه ارزیاب خسارت بالن” مسئولیتی در خصوص قوانین و خدمات این شرکت‌ها ندارد. */}
            </p>
            {/* {
                !accept &&
                <>
                <div className='d-flex mt20' style={{direction: "rtl"}}>

                <label className='custom-checkbox mt5'>
                    <input type='checkbox' checked={acceptance} onChange={(e) => setAcceptance(e.target.checked)}/>
                    <span className='checkmark'/>
                </label>
                <p className='mr35'>{t('Rules and condition')} {t('NotifModal i read and accept')}</p>
                </div>
                
                <button
                className={`btn btn-block btn-rules mt20 btn-circle ${acceptance ? 'btn-white-purple':'btn-disable'}`}
                disabled={!acceptance}
                onClick={submit}
                >
                    {t('Submit')} 
                </button>
            </>} */}
            {/* { !!accept &&
            <div className='d-flex mt20'style={{'justifyContent' : 'end'}}>
                <h5 style={{fontSize: '16px'}}>{t('Rules and condition')} {t('NotifModal Accepted message')}</h5>
                <i className='fas fa-check pl10' style={{'fontSize':23,'color':'#59f559'}}/>
            </div>
            } */}
            
        </div>
    );

};